import Card from './PressCard';
import  styled from 'styled-components';
import React from "react";

const CardWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const CardWrap1 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  @media only screen and (min-width: 1200px) {
    display: none;
  }
  @media only screen and (max-width: 650px) {
    flex-direction: column;
    margin: 0 auto;
  }
`;

// eslint-disable-next-line react/prefer-stateless-function
export default () => (
  <div style={{ textAlign: 'center' }}>
    <CardWrap>
    <Card
      imgurl="/press/inc42.png"
      body="Pune-headquartered GigIndia, which provides micro-jobs to students has raised an undisclosed amount of Seed..."
      news="https://inc42.com/buzz/micro-jobs-providing-startup-gigindia-raises-seed-funding-from-angel-investors/"
    />
    <Card
      imgurl="/press/yahoo.png"
      body="GigIndia Pocket Money, Part Time Jobs for Students is another great money making app for college students in India..."
      news="https://in.finance.yahoo.com/news/5-apps-students-money-while-114713054.html"
    />
    <Card
      imgurl="/press/fexpress.png"
      body="... Pune-headquartered GigIndia, which provides micro-jobs to students, launched its portal in 2017, the focus..."
      news="https://www.financialexpress.com/industry/the-freelance-army-why-many-indians-are-choosing-part-time-over-full-time/1407756/"
    />
    <Card
      imgurl="/press/dailyhunt.png"
      body="GigIndia Pocket Money, Part Time Jobs for Students is another great money making app for college students in India..."
      news="https://m.dailyhunt.in/news/india/english/newsbytes-epaper-newbyt/5+apps+for+students+to+make+money+while+in+college-newsid-104070710"
    />
    </CardWrap>
    <CardWrap1>
    <Card
      imgurl="/press/inc42.png"
      body="Pune-headquartered GigIndia, which provides micro-jobs to students has raised an undisclosed amount of Seed..."
      news="https://inc42.com/buzz/micro-jobs-providing-startup-gigindia-raises-seed-funding-from-angel-investors/"
    />
    <Card
      imgurl="/press/yahoo.png"
      body="GigIndia Pocket Money, Part Time Jobs for Students is another great money making app for college students in India..."
      news="https://in.finance.yahoo.com/news/5-apps-students-money-while-114713054.html"
    />
    </CardWrap1>
    <CardWrap1>
    <Card
      imgurl="/press/fexpress.png"
      body="... Pune-headquartered GigIndia, which provides micro-jobs to students, launched its portal in 2017, the focus..."
      news="https://www.financialexpress.com/industry/the-freelance-army-why-many-indians-are-choosing-part-time-over-full-time/1407756/"
    />
    <Card
      imgurl="/press/dailyhunt.png"
      body="GigIndia Pocket Money, Part Time Jobs for Students is another great money making app for college students in India..."
      news="https://m.dailyhunt.in/news/india/english/newsbytes-epaper-newbyt/5+apps+for+students+to+make+money+while+in+college-newsid-104070710"
    />
    </CardWrap1>
  </div>
);
